import React from 'react';

const About = ({ userData }) => {
  const fullName = userData ? `${userData.first_name || ''} ${userData.last_name || ''}`.trim() : '';
  
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Learn About Us, {fullName || 'Guest'}!</h1>
      <div style={styles.content}>
        <p style={styles.description}>
          Welcome to our application. This is the about page where you can learn more about our services and mission.
        </p>
        <p style={styles.description}>
          We are dedicated to providing the best experience for our users and helping them achieve their goals.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '2rem',
    maxWidth: '800px',
    margin: '0 auto'
  },
  title: {
    fontSize: '2rem',
    marginBottom: '1rem',
    color: '#333'
  },
  content: {
    maxWidth: '800px'
  },
  description: {
    fontSize: '1.1rem',
    color: '#666',
    lineHeight: '1.6',
    marginBottom: '1rem'
  }
};

export default About; 